import { useDatasource as useDs } from "@nexcodepl/endpoint-client";
import { EndpointDefinition } from "@nexcodepl/endpoint-types";

export function useDatasource<TEndpoint extends EndpointDefinition<any, any, any, boolean>>(endpointDefinition: TEndpoint) {
    return useDs({ ...endpointDefinition, url: APP_CONFIG.API_URL + endpointDefinition.url });
}
